import react from "react";
import "./StatusChip.css";

interface ChipProp {
  status: string | number | null;
  color?: string;
  backgroundcolor?: string;
  icon?: React.ReactNode;
}

const StatusChip: React.FC<ChipProp> = ({
  status,
  color,
  backgroundcolor,
  icon,
}) => {
  return (
    <div style={{ background: backgroundcolor }} className="chip-main">
      <div style={{ color: color }} className="chip-icon">
        {icon}{" "}
      </div>{" "}
      <div className="chip-status" style={{ color: color }}>
        {status}
      </div>
    </div>
  );
};

export default StatusChip;
